import { MutateOptions, useQueryClient } from "@tanstack/react-query";
import {
  useAuthQuery,
  useAuthMutation,
  UseQueryExtendedOptions,
} from "@rentablo/api";
import {
  createAccountHolder,
  GetAccountHoldersParams,
  loadAccountHolder,
  loadAccountHolders,
  updateAccountHolder,
} from "@api/v1/methods";
import {
  AccountHolder,
  PageableAccountHolderList,
  UpdateAccountHolderParams,
} from "@api/v1/model";

import { GET_ACCOUNT_HOLDERS } from "../../cacheKeys";

export const useCreateAccountHolder = () => {
  const queryClient = useQueryClient();
  return useAuthMutation(createAccountHolder, {
    throwOnError: true,
    onSuccess: () => {
      queryClient.removeQueries({
        queryKey: [GET_ACCOUNT_HOLDERS],
      });
    },
  });
};

export const useUpdateAccountHolder = (
  // TODO: add error type
  options: MutateOptions<
    AccountHolder,
    AxiosApiError,
    UpdateAccountHolderParams
  > = {}
) =>
  useAuthMutation(updateAccountHolder, {
    throwOnError: true,
    ...options,
  });

export const useAccountHolder = (
  id?: number,
  options: UseQueryExtendedOptions<
    AccountHolder,
    AxiosApiError,
    AccountHolder
  > = {
    enabled: !!id,
  }
) =>
  useAuthQuery(
    ["account-holder", id!],
    ({ token }) => loadAccountHolder(token, id!),
    options
  );

export const useAccountHolders = (
  params: GetAccountHoldersParams = {},
  options: UseQueryExtendedOptions<
    PageableAccountHolderList,
    AxiosApiError,
    PageableAccountHolderList
  > = { enabled: true }
) =>
  useAuthQuery(
    [GET_ACCOUNT_HOLDERS, params],
    ({ token }) => loadAccountHolders(token, params),
    options
  );
